import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    paddingTop: '20px',
    overflow: 'hidden',

    '& > *': {
      marginRight: '8px'
    }
  },

  arrow: {
    position: 'absolute',
    bottom: '20px',
    marginRight: '0',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#F8D8FF',
    filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.24))'
  }
}))

export default useStyles
